export default "__VITE_ASSET__Bo0RzVFk__"